export const countries = [
  "Brazil", "Vietnam", "Colombia", "Indonesia", "Ethiopia", "Honduras", "India", "Uganda", "Mexico", "Guatemala",
  "Peru", "Nicaragua", "China", "Ivory Coast", "Costa Rica", "Kenya", "Papua New Guinea", "Tanzania", "El Salvador",
  "Ecuador", "Cameroon", "Laos", "Madagascar", "Gabon", "Thailand", "Venezuela", "Rwanda", "Burundi", "Yemen", "Panama",
  "Bolivia", "Timor-Leste", "Jamaica", "Cuba", "Dominican Republic", "Haiti", "Philippines", "Congo"
].sort();
